function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "nz086ye4la",
  d: "M14.82 14.82c-.594.595-1.295 1.045-2.058 1.336l-.341-2.188c.323-.172.622-.393.888-.66.268-.268.487-.568.656-.887l2.191.34c-.29.764-.74 1.465-1.336 2.06m-4.153 1.72c-.407 0-.808-.042-1.198-.122l.33-2.117c.281.066.572.101.868.101.296 0 .586-.035.867-.101l.33 2.117c-.39.08-.79.122-1.197.122m-5.49-3.78l2.189-.34c.172.323.393.622.659.888s.565.487.887.658l-.34 2.19c-.764-.291-1.464-.742-2.06-1.337-.594-.594-1.044-1.295-1.335-2.058m-.385-2.095c0-.407.042-.808.123-1.197l2.117.33c-.067.28-.102.57-.102.867 0 .296.035.586.102.867l-2.117.33c-.08-.39-.123-.79-.123-1.197m1.72-4.154c.596-.595 1.296-1.045 2.06-1.336l.34 2.191c-.319.17-.619.388-.887.657-.266.266-.487.565-.66.888l-2.188-.341c.291-.764.741-1.464 1.336-2.06m4.154-1.72c.407 0 .807.042 1.197.123l-.33 2.123c-.57-.135-1.164-.135-1.734 0l-.33-2.123c.39-.08.79-.123 1.197-.123m0 8.374c-.668 0-1.296-.26-1.768-.732s-.732-1.1-.732-1.767c0-.668.26-1.296.732-1.768.488-.487 1.128-.73 1.768-.73.64 0 1.28.243 1.767.73.472.472.732 1.1.732 1.768 0 .667-.26 1.295-.732 1.767s-1.1.732-1.767.732m5.49-4.594l-2.192.34c-.17-.319-.388-.619-.656-.887-.269-.269-.57-.487-.889-.657l.342-2.191c.763.291 1.464.741 2.058 1.336.595.595 1.045 1.295 1.336 2.059M14.296 9.8l2.123-.33c.08.39.122.79.122 1.197 0 .407-.042.807-.122 1.197l-2.123-.33c.135-.57.135-1.164 0-1.734m1.399-4.162c-1.343-1.343-3.129-2.082-5.028-2.082-1.9 0-3.686.74-5.029 2.082-1.343 1.344-2.082 3.13-2.082 5.029 0 1.9.74 3.685 2.082 5.028 1.344 1.343 3.13 2.083 5.029 2.083 1.9 0 3.685-.74 5.028-2.083 1.343-1.343 2.083-3.129 2.083-5.028 0-1.9-.74-3.685-2.083-5.029"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-13 -459) translate(0 87) translate(8 335.506) translate(0 32) translate(5.333 5.333)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "alzw9r8wyb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#nz086ye4la"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#nz086ye4la"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#alzw9r8wyb)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H21.333V21.333H0z",
  transform: "matrix(1 0 0 -1 0 21.333)"
}))))))));

function SvgIconUserGuide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserGuide);
export default __webpack_public_path__ + "static/media/icon-user-guide.5d79d639.svg";
export { ForwardRef as ReactComponent };